/* src/app/order/components/company-general-info/employees-input-component/employees-input.style.scss */
.employees-input {
  max-width: 250px;
  display: flex;
  flex-direction: column;
}
.employee-number-exceed-popup {
  font-family: Arial, sans-serif;
  max-width: 400px;
  margin: 30px 30px 30px 30px;
}
.popover-contact {
  color: #007d40;
  font-weight: bold;
}
.employees-count-hint {
  color: #8C8C8C;
  font-size: 12px;
  line-height: 1.33;
  margin-top: 6px;
}
@media screen and (max-width: 767px) {
  .employees-input {
    width: 100%;
    max-width: 100%;
  }
}
/*# sourceMappingURL=employees-input.style.css.map */
